import { useState, useMemo } from "react";
import { MediaQueries } from "../../const/BreakpointsMediaQueries";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import verEventoBlanco from "../../assets/img/comprarTicketsBlanco.svg";
import verEventoNegro from "../../assets/img/comprarTicketsNegro.svg";
import eventsData from "./../events.json";

const Fechas = () => {
	const [show, setShow] = useState("");
	const { isTabletOrMobile } = MediaQueries();

	// Función para convertir fecha string a Date object
	const parseEventDate = (dateStr) => {
		const parts = dateStr.split("-");
		const day = parseInt(parts[0]);
		const month = parseInt(parts[1]) - 1;

		let year;
		if (parts[2]) {
			const yearPart = parts[2];
			if (yearPart.length === 2) {
				year = parseInt("20" + yearPart);
			} else {
				year = parseInt(yearPart);
			}
		} else {
			const now = new Date();
			const currentYear = now.getFullYear();
			const currentMonth = now.getMonth();

			if (
				month < currentMonth ||
				(month === currentMonth && day < now.getDate())
			) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}
		}

		return new Date(year, month, day);
	};

	// Ordenar eventos por fecha
	const eventos = useMemo(() => {
		return [...eventsData].sort(
			(a, b) =>
				parseEventDate(a.date) - parseEventDate(b.date)
		);
	}, []);

	const handleClick = () => {
		setShow(!show);
	};

	return (
		<section className='flex section-fechas'>
			{eventos.map((evento, index) => {
				const imageUrl = evento.src;
				return (
					<div
						className='row row-fechas g-0'
						key={index}>
						<div className='col-sm'>
							<img
								src={evento.src}
								alt={evento.alt}
								className='w-100'
								id='imagenAColor'
							/>
						</div>
						<div
							id={
								index % 2 === 0
									? "blanco"
									: "negro"
							}
							className='col-sm linea-flecha'>
							<div
								className='col-sm'
								id='div-fechas'>
								<h2 className='title-fecha'>
									{
										evento.titulo
									}
								</h2>
								<h4 className='title-fecha'>
									{
										evento.lugar
									}
								</h4>
								<h4 className='date-fecha'>
									{
										evento.fecha
									}
								</h4>
								<h4 className='date-fecha'>
									{
										evento.venue
									}
								</h4>
								{evento.url !==
								"" ? (
									<a
										href={
											evento.url
										}
										target='_blank'
										rel='noreferrer'>
										<img
											src={
												index %
													2 ===
												0
													? verEventoNegro
													: verEventoBlanco
											}
											width={
												70
											}
											height={
												70
											}
											alt='verEvento'
											className='prueba'
										/>
									</a>
								) : null}
							</div>
						</div>
					</div>
				);
			})}
		</section>
	);
};

export default Fechas;
